import React, { useMemo, forwardRef } from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import ListContext from './ListContext';
import styles from './List.module.css';

const List = forwardRef(function List(props, ref) {
  const {
    children,
    className,
    component: Component = 'ul',
    dense = false,
    disablePadding = false,
    subheader,
    ...other
  } = props;

  const context = useMemo(() => ({ dense }), [dense]);

  return (
    <ListContext.Provider value={context}>
      <Component
        className={cn(
          styles.root,
          {
            [styles.dense]: dense,
            [styles.padding]: !disablePadding,
            [styles.subheader]: subheader,
          },
          className,
        )}
        ref={ref}
        {...other}
      >
        {subheader}
        {children}
      </Component>
    </ListContext.Provider>
  );
});

/* eslint-disable */
List.propTypes = {
  children: Type.node,
  className: Type.string,
  component: Type.elementType,
  dense: Type.bool,
  disablePadding: Type.bool,
  subheader: Type.node,
};
/* eslint-enable */

export default List;
